import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import FontIcon from 'material-ui/FontIcon';
import './searchConsoleCard.scss'

const ICON_INCREASE = "arrow_upward"
const ICON_DECREASE = "arrow_downward"

export default class SearchConsoleCard extends React.Component {
  static propTypes = {
    title: React.PropTypes.string.isRequired,
    currentMetric: React.PropTypes.number,
    previousMetric: React.PropTypes.number,
    metricSuffix: React.PropTypes.string,
    selected: React.PropTypes.bool,
    onSelect: React.PropTypes.func,
    placeholder: React.PropTypes.bool,
    compact: React.PropTypes.bool
  }

  metricEvolution(key, currentMetric, previousMetric) {
    if (currentMetric === previousMetric) return 0
    if (key === 'position') return previousMetric - currentMetric
    return currentMetric - previousMetric
  }

  renderMetricComparison() {
    if (!this.props.previousMetric) return <div></div> // show nothing if nothing to compare with

    const previousMetric = this.props.previousMetric
    const currentMetric = this.props.currentMetric

    const metricTrend = this.metricEvolution(this.props.metricKey, currentMetric, previousMetric)
    let iconClass = "material-icons small-spacing2--right small-spacing2-bottom"
    let text, icon

    if (metricTrend > 0) {
      iconClass = `${iconClass} green`
      icon = ICON_INCREASE
      text = `Up from ${previousMetric}${this.metricSuffix()}`
    } else if (metricTrend < 0) {
      iconClass = `${iconClass} red`
      icon = ICON_DECREASE
      text = `Down from ${previousMetric}${this.metricSuffix()}`
    } else {
      text = "No change"
    }

    return (
      <div className="flex-center small-spacing--top">
        { icon && <FontIcon className={iconClass} style={{fontSize: 20}}>{icon}</FontIcon> }
        <p>{text}</p>
      </div>
    )
  }

  metricSuffix() {
    return this.props.metricSuffix || ""
  }

  renderPlaceholder() {
    const isSelected = this.props.compact && this.props.title === 'Total Impressions'

    return (
      <div className={`search-console-card ${isSelected ? 'selected' : ''}`}>
        <Card 
          style={{borderRadius: 10, height: '100%'}}
          containerStyle={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%', paddingBottom: 0}}
        >
          <CardText className="flex-center search-console-card__content-container" style={{height: '100%'}}>
            <div className="search-console-card__content">
              <h5 className="search-console-card__title">{ this.props.title }</h5>
              {!this.props.compact && <div className="search-console-card__noContent">Data Unavailable</div>}
            </div>
          </CardText>
        </Card>
      </div>
    )
  }

  render() {
    if (this.props.placeholder) return this.renderPlaceholder()

    return (
      <div className={`search-console-card ${this.props.selected ? 'selected' : ''}`}>
        <Card 
          style={{borderRadius: 10, height: '100%'}}
          containerStyle={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%', paddingBottom: 0}}
          onClick={this.props.onSelect}
        >
          <CardText className="flex-center search-console-card__content-container" style={{height: '100%'}}>
            <div className="search-console-card__content">
              <h5 className="search-console-card__title">{ this.props.title }</h5>
              {!this.props.compact && <h1>{ this.props.currentMetric.toLocaleString() }{this.metricSuffix()}</h1>}
              {/*{this.renderMetricComparison()}*/}
            </div>
          </CardText>
        </Card>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/search_console/SearchConsoleCard.js